export default "__VITE_ASSET__DfNidk_U__"